/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  $(document).on('click', '[data-calendar-navigate]', event => {
    const direction = $(event.currentTarget).attr('data-calendar-navigate')
    const calendar = $(event.currentTarget).parents('[data-calendar]')[0]
    calendar.hidden = true
    if (direction === 'next') {
      calendar.nextElementSibling.hidden = false
    } else {
      calendar.previousElementSibling.hidden = false
    }
  })
}
